import api from "./api.ts";

export type PracticeExamQuestion = {
  question_id: string;
  question_type: "mcq" | "short_answer";
  question_text: string;
  difficulty: "easy" | "medium" | "hard";
  options?: string[] | null;
  correct_option?: string | null;
  acceptable_answers?: string[] | null;
  keywords?: string[] | null;
  explanation: string;
  svg_code?: string | null;
};

export type PracticeExamResponse = {
  exam_id: string;
  subject: string;
  topics: string[];
  duration_minutes: number;
  questions: PracticeExamQuestion[];
};

export const generateQuestions = (
  subject: string,
  difficulty: string,
  num_questions: number = 1,
  age?: number,
  preparation_stage?: string,
  country?: string,
  mode?: 'quiz' | 'learn' | 'practice'
) => {
  const token = localStorage.getItem("token");
  return api.post(
    "/questions/generate",
    {
      request: {
        subject,
        difficulty,
        num_questions,
        age,
        preparation_stage,
        country,
        mode,
      }
    },
    {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    }
  );
};

export const generatePracticeExam = (
  subject: string,
  topics_text: string,
  num_questions: number,
  duration_minutes: number,
  age?: number,
  country: string = "UK"
) => {
  const token = localStorage.getItem("token");
  return api.post<PracticeExamResponse>(
    "/questions/practice-exam",
    {
      subject,
      topics_text,
      num_questions,
      duration_minutes,
      age,
      country,
    },
    {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    }
  );
};
